"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("modules/app/services/datahub/constants");
const DatahubService_1 = __importDefault(require("modules/app/services/datahub/DatahubService"));
const helper_1 = require("modules/app/services/datahub/helper");
class DatahubPageService {
    static sendAccessPanelEvent() {
        DatahubService_1.default.sendEvent({
            action: constants_1.EVENT_ACTIONS.INTERACT,
            event: (0, helper_1.buildInteractionEventData)({
                category: constants_1.EVENTS_CATEGORY.CONTENT.CONTENT_PAGE.NAME,
                action: constants_1.EVENTS_INTERACTIONS.CLICK,
                label: constants_1.EVENTS_LABELS.CONTENT.CONTENT_PAGE.ACCESS_PANEL
            })
        });
    }
    static sendContentPreviewEvent() {
        DatahubService_1.default.sendEvent({
            action: constants_1.EVENT_ACTIONS.INTERACT,
            event: (0, helper_1.buildInteractionEventData)({
                category: constants_1.EVENTS_CATEGORY.CONTENT.CONTENT_PAGE.CONTENT_MANAGE_PAGE,
                action: constants_1.EVENTS_INTERACTIONS.CLICK,
                label: constants_1.EVENTS_LABELS.CONTENT.CONTENT_PAGE.VIEW_PAGE
            })
        });
    }
    static sendDuplicateEvent(label) {
        DatahubService_1.default.sendEvent({
            action: constants_1.EVENT_ACTIONS.INTERACT,
            event: (0, helper_1.buildInteractionEventData)({
                category: constants_1.EVENTS_CATEGORY.DUPLICATION_CONTENT.CONTENT,
                action: constants_1.EVENTS_INTERACTIONS.CLICK,
                label
            })
        });
    }
    static sendRemoveEvent() {
        DatahubService_1.default.sendEvent({
            action: constants_1.EVENT_ACTIONS.INTERACT,
            event: (0, helper_1.buildInteractionEventData)({
                category: constants_1.EVENTS_CATEGORY.CONTENT.CONTENT_PAGE.CONTENT_MANAGE_PAGE,
                action: constants_1.EVENTS_INTERACTIONS.CLICK,
                label: constants_1.EVENTS_LABELS.CONTENT.CONTENT_PAGE.REMOVE_PAGE
            })
        });
    }
    static sendEditEvent() {
        DatahubService_1.default.sendEvent({
            action: constants_1.EVENT_ACTIONS.INTERACT,
            event: (0, helper_1.buildInteractionEventData)({
                category: constants_1.EVENTS_CATEGORY.CONTENT.CONTENT_PAGE.CONTENT_MANAGE_PAGE,
                action: constants_1.EVENTS_INTERACTIONS.CLICK,
                label: constants_1.EVENTS_LABELS.CONTENT.CONTENT_PAGE.EDIT_PAGE
            })
        });
    }
    static sendEditTitleEvent() {
        DatahubService_1.default.sendEvent({
            action: constants_1.EVENT_ACTIONS.INTERACT,
            event: (0, helper_1.buildInteractionEventData)({
                category: constants_1.EVENTS_CATEGORY.CONTENT.CONTENT_PAGE.CONTENT_MANAGE_PAGE,
                action: constants_1.EVENTS_INTERACTIONS.CLICK,
                label: constants_1.EVENTS_LABELS.CONTENT.CONTENT_PAGE.EDIT_TITLE
            })
        });
    }
    static sendCheckEvent() {
        DatahubService_1.default.sendEvent({
            action: constants_1.EVENT_ACTIONS.INTERACT,
            event: (0, helper_1.buildInteractionEventData)({
                category: constants_1.EVENTS_CATEGORY.CONTENT.CONTENT_PAGE.CONTENT_MANAGE_PAGE,
                action: constants_1.EVENTS_INTERACTIONS.CLICK,
                label: constants_1.EVENTS_LABELS.CONTENT.CONTENT_PAGE.CHECK_PAGE
            })
        });
    }
    static sendOrderEvent() {
        DatahubService_1.default.sendEvent({
            action: constants_1.EVENT_ACTIONS.INTERACT,
            event: (0, helper_1.buildInteractionEventData)({
                category: constants_1.EVENTS_CATEGORY.CONTENT.CONTENT_PAGE.CONTENT_MANAGE_PAGE,
                action: constants_1.EVENTS_INTERACTIONS.CLICK,
                label: constants_1.EVENTS_LABELS.CONTENT.CONTENT_PAGE.ORDER_PAGE
            })
        });
    }
    static sendReleaseDateEvent(type) {
        DatahubService_1.default.sendEvent({
            action: constants_1.EVENT_ACTIONS.INTERACT,
            event: (0, helper_1.buildInteractionEventData)({
                category: constants_1.EVENTS_CATEGORY.CONTENT.CONTENT_SCHEDULE
                    .CONTENT_SCHEDULE_DETAIL_TOOLTIP,
                action: constants_1.EVENTS_INTERACTIONS.HOVER,
                label: `DRIPPING_${type}` ===
                    constants_1.EVENTS_LABELS.CONTENT.CONTENT_SCHEDULE.DRIPPING_BY_DAYS
                    ? constants_1.EVENTS_LABELS.CONTENT.CONTENT_SCHEDULE.DRIPPING_BY_DAYS
                    : constants_1.EVENTS_LABELS.CONTENT.CONTENT_SCHEDULE.DRIPPING_BY_DATE
            })
        });
    }
    static sendExpirationDateEvent() {
        DatahubService_1.default.sendEvent({
            action: constants_1.EVENT_ACTIONS.INTERACT,
            event: (0, helper_1.buildInteractionEventData)({
                category: constants_1.EVENTS_CATEGORY.CONTENT.CONTENT_SCHEDULE
                    .CONTENT_SCHEDULE_DETAIL_TOOLTIP,
                action: constants_1.EVENTS_INTERACTIONS.HOVER,
                label: constants_1.EVENTS_LABELS.CONTENT.CONTENT_SCHEDULE.EXPIRATION
            })
        });
    }
}
exports.default = DatahubPageService;
